<template>
  <div class="wrapper">
    <parallax class="page-header header-filter"></parallax>
    <div class="">
      <div class="section text-center t_step">
        <div class="container md-card">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">Select Room</h2>
              <!-- <md-progress-bar
                class="md-primary"
                md-mode="buffer"
                :md-value="progressNum"
                :md-buffer="progressNum"
              ></md-progress-bar> -->
            </div>
            <md-steppers md-alternative md-linear :md-active-step.sync="active" :md-editable="false">
              <md-step id="first" md-label="First Step - Choose Check In&Out Dates" :md-editable="false" :md-done.sync="first">
              </md-step>
              <md-step id="second" md-label="Second Step - Select Room" :md-editable="false" :md-done.sync="second">
              </md-step>
              <md-step id="third" md-label="Third Step - Finish Information" :md-editable="false" :md-done.sync="third">
              </md-step>
            </md-steppers>
          </div>
        </div>
      </div>
      <div class="section text-center t_content">
        <md-card class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-33 md-small-size-100 mx-auto text-left">
              <h3>Step 2: 
                <md-button
                  href="javascript:void(0)"
                  v-on:click="goBack()"
                  class="md-orange md-sm pull-right"
                  ><md-icon>keyboard_backspace</md-icon> Go Back
                </md-button>
              </h3>
              <hr>
              <h4 class="title">Booking Information</h4>
              <md-list>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Check-In Date:</span>
                  <span class="md-list-item-text title text-left">{{resData.startDate}}</span>
                </md-list-item>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Check-Out Date:</span>
                  <span class="md-list-item-text title text-left">{{resData.endDate}}</span>
                </md-list-item>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Adult Count:</span>
                  <span class="md-list-item-text title text-left">{{resData.adult}}</span>
                </md-list-item>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Children Count:</span>
                  <span class="md-list-item-text title text-left">{{resData.children}}</span>
                </md-list-item>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Currency:</span>
                  <span class="md-list-item-text title text-left">$ US Dollar</span>
                </md-list-item>
              </md-list>
            </div>
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto t_listBox" v-if="myresult">
              <div v-for="(item) in myresult" v-bind:key="item.id" class="md-size-100 t_roomList">
                <div class="t_rLeft" v-if="item.capable >= resData.adult">
                  <div class="t_tabContent" :style="'width:' + width + 'px;height:' + height + 'px;'">
                    <img class="t_img" :class="{active:classicModal[item.id][0]==true}" :src="getImgUrl(item.type, 0)" alt="null">
                    <img class="t_img" :class="{active:classicModal[item.id][1]==true}" :src="getImgUrl(item.type, 1)" alt="null">
                    <img class="t_img" :class="{active:classicModal[item.id][2]==true}" :src="getImgUrl(item.type, 2)" alt="null">
                  </div>
                  <div class="elevation">
                    <md-content class="md-elevation">
                      <a href="javascript:void(0)" @mouseover="classicTab(item.id, 0)" :class="{active:classicModal[item.id][0]==true}">
                        <img :src="getImgUrl(item.type, 0)" class="img-raised" alt="null">
                      </a>
                    </md-content>
                    <md-content class="md-elevation">
                      <a href="javascript:void(0)" @mouseover="classicTab(item.id, 1)" :class="{active:classicModal[item.id][1]==true}">
                        <img :src="getImgUrl(item.type, 1)" class="img-raised" alt="null">
                      </a>
                    </md-content>
                    <md-content class="md-elevation">
                      <a href="javascript:void(0)" @mouseover="classicTab(item.id, 2)" :class="{active:classicModal[item.id][2]==true}">
                        <img :src="getImgUrl(item.type, 2)" class="img-raised" alt="null">
                      </a>
                    </md-content>
                  </div>
                </div>
                <div v-if="item.capable >= resData.adult" class="t_rRight">
                  <h3 class="t_bold">
                    {{item.name}}
                  </h3>
                  <h5>
                  {{item.description}}
                  </h5>
                  <md-table>
                    <md-table-row>
                      <md-table-cell>
                        <h5 class="t_bold">
                        $ {{getNoRePrice(item)}} USD + tax/night
                        <p class="text-success">Non-refundable</p>
                        </h5>
                      </md-table-cell>
                      <md-table-cell>
                        <md-button
                          href="javascript:void(0)"
                          v-on:click="selectedNoReRoom($event, item, getNoRePrice(item))"
                          class="md-orange md-sm"
                          ><md-icon>today</md-icon>Book Now
                        </md-button>
                      </md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell>
                        <h5 class="t_bold">
                        $ {{getPrice(item)}} USD + tax/night
                        <p class="text-success">NO PREPAYMENT <br> Free Canellation</p>
                        </h5>
                      </md-table-cell>
                      <md-table-cell>
                        <md-button
                          href="javascript:void(0)"
                          v-on:click="selectedRoom($event, item, getPrice(item))"
                          class="md-orange md-sm"
                          ><md-icon>today</md-icon>I'll Reserve
                        </md-button>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </div>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { Modal } from "@/components"
  export default {
    prop: {
    },
    components: {
      Modal
    },
    data() {
      return {
        active: 'second',
        first: true,
        second: false,
        third: false,
        id: 0,
        progressNum: 66,
        currency: 0,
        classicModal: null,
        width: 0,
        height: 0,
        myImg: {
          "img1": [{
              src: require("@/assets/img/guestlist_king1.jpg")
            },
            {
              src: require("@/assets/img/guestlist_king2.jpg")
            },
            {
              src: require("@/assets/img/guestlist_king3.jpg")
          }],
          "img2": [{
              src: require("@/assets/img/guestlist_double1.jpg")
            },
            {
              src: require("@/assets/img/guestlist_double2.jpg")
            },
            {
              src: require("@/assets/img/guestlist_double3.jpg")
          }],
          "img3": [{
              src: require("@/assets/img/guestlist_double_ma1.jpg")
            },
            {
              src: require("@/assets/img/guestlist_double_ma2.jpg")
            },
            {
              src: require("@/assets/img/guestlist_double_ma3.jpg")
          }],
          "img4": [{
              src: require("@/assets/img/guestlist_one_king1.jpg")
            },
            {
              src: require("@/assets/img/guestlist_one_king2.jpg")
            },
            {
              src: require("@/assets/img/guestlist_one_king3.jpg")
          }],
          "img5": [{
              src: require("@/assets/img/guestlist_one_double1.jpg")
            },
            {
              src: require("@/assets/img/guestlist_one_double2.jpg")
            },
            {
              src: require("@/assets/img/guestlist_one_double3.jpg")
          }],
          "img6": [{
              src: require("@/assets/img/guestlist_one_deluxe1.jpg")
            },
            {
              src: require("@/assets/img/guestlist_one_deluxe2.jpg")
            },
            {
              src: require("@/assets/img/guestlist_one_deluxe3.jpg")
          }],
          "img7": [{
              src: require("@/assets/img/NK1.jpg")
            },
            {
              src: require("@/assets/img/NDD1.jpg")
            },
            {
              src: require("@/assets/img/PND2.jpg")
          }],
          "img8": [{
              src: require("@/assets/img/NK1.jpg")
            },
            {
              src: require("@/assets/img/NDD1.jpg")
            },
            {
              src: require("@/assets/img/PND2.jpg")
          }]
        },
        date:'',
        myresult: [],
        selected: {},
        resData: {
          startDate: '',
          endDate: '',
          adult: 0,
          children: 0
        },
        count: 0
      }
    },
    computed: {
      
    },
    methods: {
      getPrice: function (e) {
        var tempPrice = 0
        if (this.resData.adult <= 2) {
          tempPrice = e.twoPerson_Price
        } else if (this.resData.adult == 3) {
          tempPrice = e.threePerson_Price
        } else if (this.resData.adult >= 4) {
          tempPrice = e.fourPerson_Price
        }
        return tempPrice
      },
      getNoRePrice: function (e) {
        var tempPrice = 0
        if (this.resData.adult <= 2) {
          tempPrice = (e.twoPerson_Price * (parseFloat(e.discount) != 0 ? (1 - parseFloat(e.discount)) : 1)).toFixed(2)
        } else if (this.resData.adult == 3) {
          tempPrice = (e.threePerson_Price * (parseFloat(e.discount) != 0 ? (1 - parseFloat(e.discount)) : 1)).toFixed(2)
        } else if (this.resData.adult >= 4) {
          tempPrice = (e.fourPerson_Price * (parseFloat(e.discount) != 0 ? (1 - parseFloat(e.discount)) : 1)).toFixed(2)
        }
        return tempPrice
      },
      getImgUrl: function (e, i) {
        let temp= 'img' + e;
        return (typeof(this.myImg[temp]) !== 'undefined') ? this.myImg[temp][i].src : ''
      },
      getData: function () {
        // console.log(this.$route.params)
        // this.resData = this.$route.params
        this.count = 1
        this.id = this.$route.params.id
        return this.id, this.count
        // return this.resData, this.count
      },
      selectedNoReRoom: function (e, el, p) {
        // console.log(el)
        sessionStorage.setItem(this.id + "type", el.type);
        sessionStorage.setItem(this.id + "name", el.name);
        sessionStorage.setItem(this.id + "price", p);
        sessionStorage.setItem(this.id + "count", this.count);
        this.$router.push({name:'infoGuestConfirmNoRe', params:{
          id: this.id,
          type: el.type,
          name: el.name,
          price: p,
          count: this.count,
          startDate: this.resData.startDate,
          endDate: this.resData.endDate,
          adult: this.resData.adult,
          children: this.resData.children
        }})
      },
      selectedRoom: function (e, el, p) {
        // console.log(el)
        sessionStorage.setItem(this.id + "type", el.type);
        sessionStorage.setItem(this.id + "name", el.name);
        sessionStorage.setItem(this.id + "price", p);
        sessionStorage.setItem(this.id + "count", this.count);
        this.$router.push({name:'infoGuestConfirm', params:{
          id: this.id,
          type: el.type,
          name: el.name,
          price: p,
          count: this.count,
          startDate: this.resData.startDate,
          endDate: this.resData.endDate,
          adult: this.resData.adult,
          children: this.resData.children
        }})
      },
      getClassModal () {
        var temp = {}, that = this;
        for (var i = 0; i < that.myresult.length; i++) {
          if(typeof(that.myresult[i].id) !== 'undefined') {
            that.$set(temp, that.myresult[i].id, [true, false, false])
            that.classicModal = Object.assign({},that.classicModal, temp)
          }
        }
        return this.classicModal;
      },
      // classicModalHide(e, i) {
      //   console.log(e, i)
      //   this.classicModal[e][i] = false;
      // },
      classicTab(e, i) {
        for(let n = 0; n < this.classicModal[e].length; n++){
          this.$set(this.classicModal[e], n, false);
        }
        this.$set(this.classicModal[e], i, true);
        return this.classicModal[e][i]
      },
      goBack: function () {
        this.$router.push({path:'/chooseGuestDate', query:{
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
          adult: this.adult,
          children: this.children
        }})
      }
    },
    created () {
      let that = this
      that.getData()
      let data = JSON.stringify({"type":"guestRoom","checkInDate":sessionStorage.getItem(that.id + 'start') + " 00:00:00","checkOutDate":sessionStorage.getItem(that.id + 'end') + " 00:00:00"});
      // axios.post('/cgi-bin/php/getlistGuest.php', data).then((res) => {
      axios.post('https://www.orangetreetx.com/cgi-bin/php/getlistGuest.php', data).then((res) => {
        if(res.status === 200) {
          that.myresult = res.data.result
        } else {
          that.myresult = []
        }
        that.getClassModal()
        return that.myresult
      }).catch((error) => {
        console.log(error)
      }).finally((res) => {
        that.getClassModal()
      })
    },
    beforeMount() {
      // console.log(this.id + 'start')
      this.resData.startDate = sessionStorage.getItem(this.id + 'start')
      this.resData.endDate = sessionStorage.getItem(this.id + 'end')
      this.resData.adult = sessionStorage.getItem(this.id + 'adult')
      this.resData.children = sessionStorage.getItem(this.id + 'children')
    },
    mounted() {
      let that = this
      // this.$http.get('/api/result').then((response) => {
      //   response = response.body
      //   if (response.errno === 0) {
      //     console.log(response)
      //     this.myresult = response.result
      //   }
      // })
      // const el = Object.assign({}, {
      //   page: 1,
      //   _:1521895305719
      // })
      this.$nextTick(function () {
        let val = (document.querySelector('.t_listBox').offsetWidth - 30) / 2
        that.width = val
        that.height = val
        window.onresize = () => {
          return (() => {
            let val = (document.querySelector('.t_listBox').offsetWidth - 30) / 2
            that.width = val
            that.height = val
          })()
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
.page-header {
  height: auto;
}
.t_main {
  height: 100%;
  position: relative;
}
.t_content {
  padding-top: 0px;
  .container {
    margin-top: 0px;
    padding: 20px 20px 60px 20px;
  }
  .t_tabContent{
    position: relative;
    width: 360px;
    height:360px;
  }
  .t_img {
    transition: all 0.5s ease;
    display: block;
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    &.active{
      opacity: 1;
    }
  }
}
.md-list-item-text {
  &.text-right {
    flex-direction: row-reverse;
    padding-right:30px;
  }
  position: relative;
}
.t_roomList {
  text-align: left;
  clear: both;
  &:after{
    content: "." ; 
    display: block ;
    height: 0 ;
    clear: both ;
    visibility: hidden ;
  }
  padding: 25px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5)
}
.t_rLeft, .t_rRight{
  width: 50%;
  float: left;
}
.t_rRight{
  text-align: right;
}
.elevation {
  padding: 5px 0 5px;
  display: flex;
  flex-wrap: wrap;
  margin:0 -5px 0 -5px;
}
.md-elevation {
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33%;
  padding:5px;
  a {
    width: 100%;
    height: 100%;
    position: relative;
    transition: all 0.2s ease;
    &.active{
      border: 5px solid rgba(245, 124, 0, 1);
    }
  }
}
.t_step{
  padding: 100px 0px 10px;
  h2{
    padding-top:20px;
  }
}
.t_bold{
  font-weight: bold;
}
</style>
<style lang="scss">
  .md-steppers{
    width: 100%;
    button{
      background-color: #fff!important;
      border: none;
      box-shadow: none;
      &:hover, &:active, &:link{
        background-color: #fff!important;
        border: none;
        box-shadow: none;
        cursor: pointer;
      }
    }
  }
  .md-steppers-navigation{
    box-shadow: none!important;
  }
</style>